import { CycleUtils } from '@wix/package-picker-shared';
import { SwitchProductModule } from '@wix/package-picker-sdk';
export const useIsCurrentCycle = cycleId => {
  var _currentProductData$c;
  const {
    data: currentProductData,
    isLoading,
    isError
  } = SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const activeCycle = currentProductData == null || (_currentProductData$c = currentProductData.currentProduct) == null ? void 0 : _currentProductData$c.cycle;
  const targetCycle = CycleUtils.convertCycleIdToCycle(cycleId);
  return {
    isCurrentCycle: Boolean(targetCycle && CycleUtils.isCycleEqual(activeCycle, targetCycle)),
    isLoading,
    isError
  };
};
//# sourceMappingURL=useIsCurrentCycle.js.map